import { CSSObject } from '@chakra-ui/react';

export const ILink: CSSObject = {
  color: 'white',
  mx: '0',
  '&&': { fontFamily: 'Montserrat', color: 'alpha.500', fontSize: 'xs' },
  textDecoration: 'underline',
};
